import { Image, Radio, RadioChangeEvent } from "antd"
import { useState } from "react";
import { motion } from "framer-motion";
import { useExamStore } from "@store";

export const ImageOption = () => {
    const [checked, setChecked] = useState<string>();
 
    const currentQuestion = useExamStore((state) => state.clickedQuestion);

    const handleChange = ({ target: { value } }: RadioChangeEvent) => {
        setChecked(value);
  
      };

    return (
      <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
       <Radio.Group value={checked} style={{ width: "100%", textAlign: "center" }} onChange={handleChange} >
        {currentQuestion?.answers?.map((image, index) => (
          <Radio value={image.answerImageViewModel?.base64Value} key={index} style={{ flexDirection: "column-reverse" }}>
            <div
              style={{ width: "200px" }}
              className={
                checked === image.answerImageViewModel?.base64Value ? "custom-radio-btn-checked" : "custom-radio-btn"
              }
            >
              <Image preview={false} src={`data:image/${image.answerImageViewModel?.extension};base64,${image.answerImageViewModel?.base64Value}`} />
            </div>
          </Radio>
        ))}
      </Radio.Group>
      </motion.div>
       
    )
}